import { apiFetch } from "./apiFetch";

export function requestPlanSuggestion(itemType, payload) {
  return apiFetch("/intelligence/plan-suggestion/", {
    method: "POST",
    body: JSON.stringify({
      item_type: itemType,
      payload: payload || {},
    }),
  });
}

export function fetchPlanReview({ scope = "whole_plan", goalId = null } = {}) {
  const params = new URLSearchParams();
  if (scope) params.set("scope", scope);
  if (goalId) params.set("goal_id", String(goalId));
  const query = params.toString();
  return apiFetch(`/intelligence/plan-review/${query ? `?${query}` : ""}`);
}

export function ensurePlanReview({ allowLiveAi = true, forceRefresh = false, scope = "whole_plan", goalId = null } = {}) {
  return apiFetch("/intelligence/plan-review/ensure/", {
    method: "POST",
    body: JSON.stringify({
      allow_live_ai: allowLiveAi,
      force_refresh: forceRefresh,
      trigger_reason: "user_requested",
      scope,
      goal_id: goalId || null,
    }),
  });
}

export function applyPlanReviewSuggestion({ reviewId, suggestionId, action = "apply", userEdits = null }) {
  return apiFetch("/intelligence/plan-review/apply/", {
    method: "POST",
    body: JSON.stringify({
      review_id: reviewId,
      suggestion_id: suggestionId,
      action,
      user_edits: userEdits || {},
    }),
  });
}

export function fetchIntelligenceSummary(horizon = "daily") {
  const normalized = String(horizon || "daily");
  const query = normalized && normalized !== "daily" ? `?horizon=${encodeURIComponent(normalized)}` : "";
  return apiFetch(`/intelligence/summary/${query}`);
}

export function fetchIntelligenceAnalytics(days = 90) {
  return apiFetch(`/intelligence/analytics/?days=${encodeURIComponent(days)}`);
}

export function fetchLearnedIntelligence() {
  return apiFetch("/intelligence/learned/");
}

export function ensureDailyIntelligenceBrief(triggerReason = "first_open", { force = false } = {}) {
  return apiFetch("/intelligence/daily-brief/ensure/", {
    method: "POST",
    body: JSON.stringify({ trigger_reason: triggerReason, force }),
  });
}

export function ensureHorizonIntelligenceBrief(horizon = "weekly", { triggerReason = "first_open", force = false } = {}) {
  return apiFetch("/intelligence/horizon-brief/ensure/", {
    method: "POST",
    body: JSON.stringify({ horizon, trigger_reason: triggerReason, force }),
  });
}

export function askTrustBud(question, { allowLiveAi = true } = {}) {
  return apiFetch("/intelligence/ask/", {
    method: "POST",
    body: JSON.stringify({ question, allow_live_ai: allowLiveAi }),
  });
}

export function updatePersonalMemory(memoryId, action) {
  return apiFetch(`/intelligence/memories/${memoryId}/`, {
    method: "PATCH",
    body: JSON.stringify({ action }),
  });
}

export function recordIntelligenceAction({ actionEventId, interaction, reason = "", metadata = null }) {
  return apiFetch("/intelligence/actions/", {
    method: "POST",
    body: JSON.stringify({
      action_event_id: actionEventId,
      interaction,
      reason,
      metadata: metadata || undefined,
    }),
  });
}

export function applyIntelligenceRecommendation({ insight = {}, intent = "", commitmentId = "" }) {
  return apiFetch("/intelligence/apply-recommendation/", {
    method: "POST",
    body: JSON.stringify({
      insight,
      intent,
      commitment_id: commitmentId || undefined,
    }),
  });
}

export function updateAppliedIntelligenceChange({ action, changeId, feedback = "", note = "" }) {
  return apiFetch("/intelligence/applied-changes/", {
    method: "POST",
    body: JSON.stringify({
      action,
      change_id: changeId,
      feedback,
      note,
    }),
  });
}

export function requestNetworkEncouragement(targetUserId, context = {}) {
  return apiFetch("/intelligence/network-encouragement/", {
    method: "POST",
    body: JSON.stringify({
      target_user_id: targetUserId,
      context,
    }),
  });
}

export function sendAiFeedback({ action, taskType, recommendationId = "" }) {
  return apiFetch("/intelligence/feedback/", {
    method: "POST",
    body: JSON.stringify({
      action,
      task_type: taskType,
      recommendation_id: recommendationId,
    }),
  });
}

export function fetchAdminAiDebug() {
  return apiFetch("/admin/ai/debug/");
}
